import { defineStore } from "pinia";

import { usePackingOptionsStore } from "@/stores/modules/packingOptions";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";

export const usePreview3DStore = defineStore("preview3d", {
  state: () => ({
    url: "",
    image: [],
    td_texture: { 1: "0.1" },
    id: "preview3DPacking",
    current_td_data: null,
    activePreview: "preview3D",
    preview_3dloading: false
  }),

  getters: {
    getPreview3DLoading(state) {
      return state.preview_3dloading;
    },
    getPreview3D(state) {
      return state.url;
    },
    get3DPreviewId(state) {
      return state.id;
    },
    getImageTd(state) {
      return state.image;
    },
    getCurrentTdData(state) {
      return state.current_td_data;
    },
    getTdTexture(state) {
      const changeOptionsStore = useChangeOptionsStore();
      const webproductStore = useWebproductStore();
      if (changeOptionsStore.getPackingTdTexturesFromTemplateMapping)
        return changeOptionsStore.getPackingTdTexturesFromTemplateMapping;
      if (webproductStore.getPackingTdTextures)
        return webproductStore.getPackingTdTextures;
      return state.td_texture;
    },
    getActivePreview(state) {
      return state.activePreview;
    }
  },

  actions: {
    setPreview3D(payload) {
      this.url = payload;
    },
    setPreview3DImage(payload) {
      this.image = payload;
      this.setTdImage();
    },
    setPreview3DTexture(payload) {
      this.td_texture = payload;
    },
    setCurrentTdData(payload) {
      this.current_td_data = payload;
    },
    setActivePreview(payload) {
      this.activePreview = payload;
    },
    setPreview3DLoading(payload) {
      this.preview_3dloading = payload;
    },
    setPrintqChangeProductImage(payload) {
      if (payload.image) {
        this.setPreview3DImage(payload.image);
        this.setTdImage();
      }
    },
    setTdImage() {
      const packingOptionsStore = usePackingOptionsStore();
      var packingOptions = packingOptionsStore.getPackingOptionsData;
      var infos_td = {};
      if (packingOptions.insideTexture) {
        infos_td["insideTexture"] = packingOptions.insideTexture;
      }
      if (packingOptions.outsideTexture) {
        infos_td["outsideTexture"] = packingOptions.outsideTexture;
      }
      if (packingOptions.papercolor) {
        infos_td["papercolor"] = packingOptions.papercolor;
      }
      this.setCurrentTdData(this.getTdTexture);
      if (jQuery("#" + this.get3DPreviewId + " iframe").length) {
        jQuery("#" + this.get3DPreviewId + " iframe")
          .get(0)
          .contentWindow.postMessage(
            JSON.stringify({
              texture_upload: this.getTdTexture,
              image: this.getImageTd,
              infos_td: infos_td
            }),
            "*"
          );
      }
    }
  }
});
